// extracted by mini-css-extract-plugin
export default {"request_banner_container":"requestBanner-module__request_banner_container--rcOZi","request_banner_title":"requestBanner-module__request_banner_title--UDBYa"};